import { render, staticRenderFns } from "./CollapseMobile.vue?vue&type=template&id=4bf2db37&"
import script from "./CollapseMobile.vue?vue&type=script&lang=js&"
export * from "./CollapseMobile.vue?vue&type=script&lang=js&"
import style0 from "./CollapseMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports